import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActionData, Entities } from '../data-rules-model';
import { IEntityItem } from '../lib/paired-autocomplete/paired-autocomplete.component';
import { IActionFieldMeta, MetaDataService, MetaSource } from '../meta-data.service';

@Component({
  selector: 'app-action-base',
  template: ''
})
export class BaseActionComponent implements OnInit, OnDestroy {
  @Input() actionData: ActionData;
  @Input() formGroup: FormGroup;
  @Input() primaryEntity: Entities;
  @Input() fieldToChangeDescriptorControl: AbstractControl;

  typeControl: AbstractControl;
  sourceControl: AbstractControl;
  sourceDescriptorControl: AbstractControl;
  sourceTypeControl: AbstractControl;
  destinationControl: AbstractControl;
  destinationDescriptorControl: AbstractControl;
  destinationTypeControl: AbstractControl;
  valueControl: AbstractControl;

  dataSourceType = MetaSource.ACTION;
  entitiesOptions: IEntityItem[] = [];

  actionDestinationType;

  private sourceControlSubscription: Subscription;
  private sourceDescriptorControlSubscription: Subscription;
  private fieldToChangeDescriptorControlSubscription: Subscription;
  private destinationDescriptorControlSubscription: Subscription;
  private destinationControlSubscription: Subscription;

  constructor(protected metaDataService: MetaDataService) {
  }

  ngOnInit() {
    this.createControls();
    this.initialise();
    this.subscribeToChanges();
    this.actionDestinationType = this.formGroup.controls['destinationType'].value;
  }

  ngOnDestroy() {
    this.unsubscribeFromControls();
  }

  protected initialise(): void {
  }

  protected initialiseControls(): void {
  }

  protected sourceControlValueChange(fieldInfo: IActionFieldMeta): void {
  }

  protected destinationControlValueChange(fieldInfo: IActionFieldMeta): void {
  }

  private createControls(): void {
    this.typeControl = this.formGroup.controls['type'];   // this needs to be the string not the enum!
    this.sourceControl = this.formGroup.controls['source'];
    this.sourceDescriptorControl = this.formGroup.controls['sourceDescriptor'];
    this.sourceTypeControl = this.formGroup.controls['sourceType'];
    this.destinationControl = this.formGroup.controls['destination'];
    this.destinationDescriptorControl = this.formGroup.controls['destinationDescriptor'];
    this.destinationTypeControl = this.formGroup.controls['destinationType'];
    this.valueControl = this.formGroup.controls['value'];
    this.initialiseControls();
  }

  private subscribeToChanges(): void {
    this.sourceControlSubscription = this.sourceControl.valueChanges
        .subscribe(value => this.sourceControlValueChangeHandler(value)); // Handled in the Action Component atm
    this.sourceDescriptorControlSubscription = this.sourceDescriptorControl.valueChanges
        .subscribe(value => this.sourceDescriptorControlValueChangeHandler(value));
    this.fieldToChangeDescriptorControlSubscription = this.fieldToChangeDescriptorControl.valueChanges
        .subscribe(value => this.fieldToChangeDescriptorControlValueChangeHandler(value));
    this.destinationDescriptorControlSubscription = this.destinationDescriptorControl.valueChanges
        .subscribe(value => this.destinationDescriptorControlValueChangeHandler(value));
    this.destinationControlSubscription = this.destinationControl.valueChanges
        .subscribe(value => this.destinationControlValueChangeHandler(value));
  }

  private unsubscribeFromControls(): void {
    this.sourceControlSubscription.unsubscribe();
    this.sourceDescriptorControlSubscription.unsubscribe();
    this.fieldToChangeDescriptorControlSubscription.unsubscribe();
    this.destinationDescriptorControlSubscription.unsubscribe();
    this.destinationControlSubscription.unsubscribe();
  }

  protected getMeta(descriptorControl: string | null): Observable<IActionFieldMeta[]> {
    return this.metaDataService.filterMetaBySecondaryDescriptor(
        this.primaryEntity,
        descriptorControl,
        MetaSource.ACTION
    ).pipe(
        map(v => v as IActionFieldMeta[])
    );
  }

  private sourceControlValueChangeHandler(fieldName: string): void {
    this.getMeta(this.sourceDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {
          const meta = filteredMeta.find(fm => fm.fieldName === fieldName);
          this.sourceControlValueChange(meta);
        });
  }

  protected fieldToChangeDescriptorControlValueChangeHandler(desc?: string | null): void {
    this.metaDataService.reduceMetaToEntitiesOptions(this.primaryEntity, this.dataSourceType)
        .subscribe(entities => {
          this.entitiesOptions = entities;
        });

  }

  protected destinationControlValueChangeHandler(fieldName: string): void {
    this.actionDestinationType = this.destinationTypeControl.value;
    this.getMeta(this.destinationDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {
          const meta = filteredMeta.find(fm => fm.fieldName === fieldName);
          this.destinationControlValueChange(meta);
        });
  }

  protected destinationDescriptorControlValueChangeHandler(desc: string | null): void {
  }

  protected sourceDescriptorControlValueChangeHandler(desc: string | null): void {
  }
}
